import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import loadData from "./data";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchBlogPageDataIfNeeded } from "./data/blogPageReducer";
import { getBlogLanguageFromPath } from "@Pages/Blog/utils/blogLanguage";

const BlogPost = loadable(() => import("./BlogPost"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    let isDraft = false;
    if (typeof window !== "undefined" && window.location.pathname?.startsWith("/drafts-blog/")) {
      isDraft = true;
    }

    const lang = getBlogLanguageFromPath(window.location.pathname);

    dispatch(fetchBlogPageDataIfNeeded(props, false, false, false, "", false, isDraft, lang));
  }, [dispatch, props?.match?.params?.slug]);

  return (
    <ErrorBoundary>
      <BlogPost {...props} />
    </ErrorBoundary>
  );
};

export { BlogPost as PreFetchBlogPost };
export { loadData };
